import React, { FunctionComponent } from 'react';
import { IMeetingListProps } from './types';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { MeetingAvatar } from '../MeetingAvatar';

export const MeetingList: FunctionComponent<IMeetingListProps> = ({
  meetings,
  isSidebarCollapsed,
  droppableId,
  type,
}) => {
  return (
    <>
      <Droppable droppableId={droppableId}>
        {(provided, snapshot) => (
          <ul
            {...provided.droppableProps}
            ref={provided.innerRef}
            className={`${droppableId == '0' ? 'content-outside-folder' : 'folder-content'} ${
              snapshot.isDraggingOver ? 'droppable' : ''
            }`}
          >
            {meetings.map(
              (meeting, index) =>
                meeting && (
                  <Draggable
                    key={`${meeting.id}`}
                    draggableId={meeting.id}
                    index={index}
                    isDragDisabled={isSidebarCollapsed}
                  >
                    {(provided) => {
                      return (
                        <li>
                          <MeetingAvatar meeting={meeting} provided={provided} navigateOnClick />
                        </li>
                      );
                    }}
                  </Draggable>
                ),
            )}
            {!meetings.length &&
              (droppableId === '0' ? (
                <div style={{ height: '20px' }}></div>
              ) : (
                <li>
                  <a>
                    <span>{type === 'account' ? '0 Accounts' : '0 Meetings'}</span>
                  </a>
                </li>
              ))}
            {provided.placeholder}
          </ul>
        )}
      </Droppable>
    </>
  );
};
